import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthService } from '@ukam/shell/services/auth.service';

export const authGuard: CanActivateChildFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isPasswordChangeRequired()) {
    return router.createUrlTree(['/authentication/change-pwd']);
  }

  if (authService.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/authentication/login'], {
    queryParams: { returnUrl: state.url },
  });
};
